// extracted by mini-css-extract-plugin
export default {"sideNavbar":"SideNavbar_sideNavbar__nVEh8","right":"SideNavbar_right__LGWz3","left":"SideNavbar_left__iJZ3j"};